var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","fixed":"","bottom":"","left":"","fab":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }